module.exports = __webpack_public_path__ + "img/ywjz3.524bbc23.png";